'use client';
import * as React from 'react';

import createSvgIcon from './createSvgIcon';

const CheckboxIndeterminate = createSvgIcon(
  <g fillRule="evenodd">
    <rect width="16" height="16" x="4" y="4" rx="2" />
    <rect fill="#FFF" width="10" height="2" x="7" y="11" rx="1" />
  </g>,
  'CheckboxIndeterminate'
);

export default CheckboxIndeterminate;
